export default [
  {
    title: 'نامه',
    icon: 'MailIcon',
    children: [
      {
        title: 'نامه های دریافتی',
        icon: 'InboxIcon',
        route: 'Tickets_Inbox',
        permission: 'tickets.index',
      },
      {
        title: 'نامه های ارسالی',
        icon: 'SendIcon',
        route: 'Tickets_Sent',
        permission: 'tickets.sent',
      },
      {
        title: 'نامه جدید',
        icon: 'Edit3Icon',
        route: 'Tickets_Create',
        permission: 'tickets.store',
      },
      {
        title: 'نامه های آرشیو',
        icon: 'ArchiveIcon',
        route: 'Tickets_Archive',
        permission: 'tickets.archive',
      },
      {
        title: 'نامه های بسته شده',
        icon: 'SlashIcon',
        route: 'Tickets_Closed',
        permission: 'tickets.closed',
      },
    ],
  },
]
